<template>
  <div class="projects__list-card">
    <v-card>
      <v-card-text>
        <v-card-title style="display: flex; align-items: center; justify-content: space-between;">
          <span class="text-h5">All Projects</span>
          <div>
            <v-btn tile color="success" @click="addNewProject" style="margin-left: 16px;">
              <v-icon left>
                mdi-plus
              </v-icon>
              Add New Project
            </v-btn>
          </div>
        </v-card-title>
      </v-card-text>
      <v-card-text>
        <v-container>
          <div>
            <!-- <div class="shgc__calc">
            <Shgc />
          </div> -->
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      Project Name
                    </th>
                    <!-- <th class="text-center">
                    Surface Area Wall (sq.m)
                  </th> -->
                    <!-- <th class="text-center">
                    Overhang (V)
                  </th> -->
                    <th class="text-center">
                      WFRop
                    </th>
                    <!-- <th class="text-center">
                    VLT
                  </th> -->
                    <th class="text-center">
                      URoof
                    </th>
                    <th class="text-center">
                      RETV
                    </th>
                    <th class="text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <template v-for="shading in shadings"> -->
                  <tr v-for="(project, i) in projects">
                    <td>{{ project.project_name }}</td>
                    <!-- <td class="text-center">{{ project.schema.inputs.step2.summary_step2.surface_area_wall }}</td> -->
                    <td><v-icon v-if="project.schema.inputs.step4.wfropObj.wfropPercent && project.schema.inputs.step4.wfropObj.wfropPercent > project.schema.inputs.step4.wfropObj.minWfropPercent">mdi-check-circle</v-icon><v-icon v-else-if="project.schema.inputs.step4.wfropObj.wfropPercent < project.schema.inputs.step4.wfropObj.minWfropPercent">mdi-close-circle</v-icon></td>

                    <!-- <td><v-icon>mdi-check-circle</v-icon><v-icon>mdi-close-circle</v-icon></td> -->
                    <td><v-icon v-if="project.schema.inputs.step5A.roof_u_value && project.schema.inputs.step5A.roof_u_value <= 1.2">mdi-check-circle</v-icon><v-icon v-else-if="project.schema.inputs.step5A.roof_u_value > 1.2">mdi-close-circle</v-icon></td>
                    <td><v-icon v-if="project.schema.inputs.retv6C.retv < 15 && project.schema.inputs.retv6C.retv !== 0">mdi-check-circle</v-icon><v-icon v-else-if="project.schema.inputs.retv6C.retv > 15">mdi-close-circle</v-icon></td>
                    <td class="text-center">
                      <v-btn icon fab @click="deleteProject(i)" x-small color="red">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <!-- </template> -->
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </v-container>
      </v-card-text>
      <shgc v-if="showModal" :show="showModal" @close="showModal = false" :shading="selectedShading" />
    </v-card>
  </div>
</template>

<script>
import Shgc from '@/components/shgc/Shgc.vue';
import { defaultSchema } from '@/store/default';
export default {
  components: {
    Shgc,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    projects: {
      get: function() {
        return this.$store.state.projects;
      },
      set: function(newProjects) {
        this.$store.dispatch('setProjects', newProjects);
      },
    },
    step4: {
      get: function() {
        return this.$store.state.schema.inputs.step4;
      },
      set: function(step4) {
        this.$store.dispatch('setStep4', step4);
      },
    },
    step5A: {
      get: function() {
        return this.$store.state.schema.inputs.step5A;
      },
      set: function(step5A) {
        this.$store.dispatch('setStep5A', step5A);
      },
    },
  },
  mounted() {
    console.log('Projects', this.projects);
  },
  methods: {
    addNewProject() {
      let newProjectIndex = this.projects[this.projects.length - 1] ? parseInt(this.projects[this.projects.length - 1].project_index) + 1 : 1;
      let newProject = {
        project_name: `Project ${newProjectIndex}`,
        project_icon: 'light-icon-stack',
        project_path: `project-${newProjectIndex}`,
        project_index: newProjectIndex,
        schema: { ...defaultSchema },
      };
      newProject.schema.inputs.step1.project_name = newProject.project_name;
      this.projects.push(newProject);
    },
    deleteProject(index) {
      this.projects.splice(index, 1);
    },
    // editShading(id) {
    //   let index = this.shadings.findIndex(item => item.id === id);
    //   if (index !== -1) {
    //     this.selectedShading = this.shadings[index];
    //     this.showModal = true;
    //   }
    // },
    // addShading() {
    //   this.selectedShading = null;
    //   this.showModal = true;
    // },
    // resetShadings() {
    //   this.shadings = JSON.parse(JSON.stringify(defaultShadings));
    //   localStorage.setItem('shadings', JSON.stringify(defaultShadings));
    // },
  },
};
</script>

<style lang="scss">
.shgc__calc {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}
.projects__list-card {
  margin-top: 124px;
  display: flex;
  justify-content: center;
}
</style>
